// Centralized React Query defaults for finance hooks
// Uses stale-while-revalidate: show cached data instantly, refresh in background
export const reactQueryFinanceDefaults = {
  staleTime: 1000 * 60 * 10,      // 10 minutes - data considered fresh, no background refetch
  gcTime: 1000 * 60 * 60 * 24,    // 24 hours - keep in cache for instant page loads
  retry: 2,
  retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
};
